import { Resume, SingleTemplateConfigSettings, SingleTemplateSettings } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'
import { useGetFontWeights } from '../hooks/useGetFontWeights'
import { SelectInput } from '../../SelectInput/SelectInput'
import { FontWeightFieldIds } from '../types'
import { TEXT_TAB_TRANSLATION } from '../constants'
import * as Styles from './styles'

type Props = {
  resume: Resume
  currentTemplate: SingleTemplateConfigSettings
  resumeSpecificTemplateSettings: SingleTemplateSettings
}

type Input = {
  key: FontWeightFieldIds
  selected: string
}

export const FontWeight = (props: Props) => {
  const { resume, currentTemplate, resumeSpecificTemplateSettings } = props

  const { i18n } = useI18n()
  const {
    options,
    onSelectFontWeight,
    getFontWeightLabel,
    primarySelected,
    secondarySelected,
    bodySelected,
    sectionTitlesSelected,
  } = useGetFontWeights({
    resume,
    currentTemplate,
    resumeSpecificTemplateSettings: resumeSpecificTemplateSettings,
  })

  const inputs: Input[] = [
    { key: 'primaryFontWeight', selected: primarySelected },
    { key: 'secondaryFontWeight', selected: secondarySelected },
    { key: 'bodyFontWeight', selected: bodySelected },
    { key: 'sectionTitlesFontWeight', selected: sectionTitlesSelected },
  ]

  if (!currentTemplate?.supportsFontWeightsCustomization) return null

  return (
    <Styles.Container>
      <Styles.Header>{i18n.t(`${TEXT_TAB_TRANSLATION}.font_weight.title`)}</Styles.Header>
      <Styles.InfoBoxComponent
        type="info"
        text={i18n.t(`${TEXT_TAB_TRANSLATION}.font_weight.info_text`)}
      />
      {inputs.map(input => (
        <SelectInput
          key={input.key}
          name={getFontWeightLabel(input.key)}
          options={options}
          selected={input.selected}
          onSelect={value => onSelectFontWeight(input.key, value)}
        />
      ))}
    </Styles.Container>
  )
}
